export default __webpack_public_path__ + "static/media/Relikof-2.5_Eng.f878d93d.jpg";